import { ReplyService } from "../Services/ReplyService";
import { PublicSiteService, householdPersonAnswer } from "../Services/PublicSiteService";
import { Time } from "../Types/Time";
import { timeAnswers, updateReplyRequest } from "../Types/RequestResponse/createReplyRequest";
import { createReplyRequest } from "../Types/RequestResponse/createReplyRequest";

export const useSaveReply = () => {
  const getTimeAnswers = (formValues: any, times: Time[]) => {
    let timeAnswers: timeAnswers[] = [];
    times.forEach(function (time) {
      if (formValues[time.id]) {
        timeAnswers.push({
          timeId: time.id,
          customerAnswer: Number(formValues[time.id])
        })
      }
    });

    return timeAnswers;
  };

  // The reply of a logged in member. Name and e-mail come from the member register on the server.
  // people: the people of the household to sign up with their answers, when the member answers for the household.
  const SaveMemberReply = async (eventUniqueId: string, formValues: any, times: Time[], people?: householdPersonAnswer[]) => {
    return await PublicSiteService.SaveEventReply({
      eventUniqueId: eventUniqueId,
      answer: formValues.answer,
      timeAnswers: people != null ? [] : getTimeAnswers(formValues, times),
      people: people
    });
  };

  // A primary member signs up the household through the personal invite.
  const SaveHouseholdReply = async (eventId: number, inviteId: string, answer: string, people: householdPersonAnswer[]) => {
    return await ReplyService.SaveHousehold({
      eventId: eventId,
      inviteId: inviteId,
      answer: answer,
      people: people
    });
  };

  const SaveReply = async (eventId: number, formValues: any, times: Time[], inviteId?: string, replyId?: number, authCode?: string) => {
    const timeAnswers = getTimeAnswers(formValues, times);

    if (!replyId || replyId == 0) {
      const createEventRequest: createReplyRequest = {
        name: formValues.name,
        eventId: eventId,
        email: formValues.email,
        answer: formValues.answer,
        timeAnswers: timeAnswers,
        inviteId: inviteId
      }

      return await ReplyService.CreateReply(createEventRequest);
    }
    else {
      const createEventRequest: updateReplyRequest = {
        name: formValues.name,
        eventId: eventId,
        email: formValues.email,
        answer: formValues.answer,
        timeAnswers: timeAnswers,
        inviteId: inviteId,
        replyId: replyId,
        authCode: authCode
      }

      return await ReplyService.UpdateReply(createEventRequest);
    }


  };
  return {
    SaveReply,
    SaveMemberReply,
    SaveHouseholdReply
  };
};